export const PI2 = Math.PI * 2;
export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;
export const NumberEpsilon = 1e-6;
export function isZero(v) {
    return isNaN(v) || Math.abs(v) < NumberEpsilon;
}
export function isEqual(a, b) {
    return Math.abs(a - b) < NumberEpsilon || (a === Infinity && b === Infinity) || (a === -Infinity && b === -Infinity);
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
export const damp = (x, y, lambda, dt) => lerp(x, y, 1 - Math.exp(-lambda * dt));
// https://en.wikipedia.org/wiki/Linear_interpolation
export const lerp = (x, y, t) => (1 - t) * x + t * y;
export const degToRad = (degrees) => degrees * DEG2RAD;
export const radToDeg = (radians) => radians * RAD2DEG;
export function clamp(value, min, max) {
    const fixedMin = isNaN(min) ? -Infinity : min;
    const fixedMax = isNaN(max) ? Infinity : max;
    const lower = Math.min(fixedMin, fixedMax);
    const upper = Math.max(fixedMin, fixedMax);
    return Math.min(Math.max(value, lower), upper);
}
